"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Nep17Contract = void 0;
const ContractParam_1 = require("../ContractParam");
const ContractMethodDefinition_1 = require("../manifest/ContractMethodDefinition");
const BaseContract_1 = require("./BaseContract");
const Nep17TemplateAbi_json_1 = __importDefault(require("./templates/Nep17TemplateAbi.json"));
/**
 * A standard NEP-17 contract according to specification.
 */
class Nep17Contract extends BaseContract_1.BaseContract {
    /**
     * The list of methods found on the NEP-5 specification.
     */
    static getMethods() {
        return Nep17TemplateAbi_json_1.default.methods.map((m) => ContractMethodDefinition_1.ContractMethodDefinition.fromJson(m));
    }
    constructor(scriptHash, additionalMethods = []) {
        super(scriptHash, Nep17Contract.getMethods().concat(additionalMethods));
    }
    symbol() {
        return this.call("symbol");
    }
    decimals() {
        return this.call("decimals");
    }
    /**
     * Retrieves the balance of the address.
     * The balance returned will be an integer which needs to be processed according to the number of decimals for this token.
     *
     * @param address - The address to enquire.
     *
     * @example
     * const contract = new Nep17Contract(contractHash);
     * const balanceOfCall = contract.balanceOf(address);
     * const result =
     */
    balanceOf(address) {
        return this.call("balanceOf", ContractParam_1.ContractParam.hash160(address));
    }
    totalSupply() {
        return this.call("totalSupply");
    }
    /**
     * Transfers some token between addresses.
     * The amount of tokens needs to be
     * @param from - The address from where the funds originate.
     * @param to - The address where the funds will arrive at.
     * @param amount - The amount of tokens to transfer in integer format.
     */
    transfer(from, to, amount, data) {
        return this.call("transfer", ContractParam_1.ContractParam.hash160(from), ContractParam_1.ContractParam.hash160(to), ContractParam_1.ContractParam.integer(amount), ContractParam_1.ContractParam.any(data));
    }
}
exports.Nep17Contract = Nep17Contract;
